import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const OrbitPage = () => {

    const media = 
    [
        '/images/orbit_1.webp', 
        '/images/orbit_2.webp'
    ];

  return (
    <div className="orbit-page">
      
 <ProjectTemplate
title="orbit"
year="2020"
  sections={[
    {
      type: 'description',
      text: 'orbit is a granular synthesis tool combining the sound of superCollider with visuals from openFrameworks. It is based on a gravitational model where every element attracts each other, influencing their oscillating paths. Each "ball" or "planet" represents a grain of which its granular characteristics are determined by its position in three-dimensional space. The total sound is thus modulated by gravitational forces.',
    },
    {
      type: 'video',
      links: ['https://www.youtube.com/embed/7W2KbbqzT9k?si=bCSb7qJPNCBoe_Oj?controls=1&modestbranding=1&rel=0&showinfo=0']
    }, 
    {
      type: 'image', 
      links: 
      [
        {
            src: media[0]
        }      
    ],
      isLink: false, 
    },
    {
        type: 'image', 
        links: 
        [
            {
                src: media[1]
            }        
        ],
        isLink: false, 
    },
    {
            type: 'video',
            links: ['https://www.youtube.com/embed/QgEfa1WeAS8?si=uYUEQVTweTwQfdxF?controls=1&modestbranding=1&rel=0&showinfo=0']
    }, 
  ]}
  
/>

    </div>
  );
};

export default OrbitPage;
